import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Application } from './Application.js';
import './styles/index.css';

const racine = document.getElementById('racine');
if (racine === null) throw new Error('#racine absent de index.html');
createRoot(racine).render(<StrictMode><Application /></StrictMode>);
